import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {InvoiceCreatedNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";

/**
 * Invoice created notification class.
 */
export default class InvoiceCreatedNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if notification is marked as read.
	 * @param {string} type in this case always 'INVOICE_CREATED'.
	 * @param {InvoiceCreatedNotificationData} data invoice created notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: InvoiceCreatedNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): InvoiceCreatedNotification {
		return new InvoiceCreatedNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			InvoiceCreatedNotificationData.fromJson(json.data as InvoiceCreatedNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new InvoiceCreatedNotification(id, dateTime, read, type, data);
	}
}

/**
 * Invoice created notification class data.
 */
export class InvoiceCreatedNotificationData {
	constructor(readonly jobRefNumber: string) {}

	static fromJson(json: InvoiceCreatedNotificationDataApiDto): InvoiceCreatedNotificationData {
		return new InvoiceCreatedNotificationData(json.jobRefNumber)
	}
}
